/* ---------------------------------------------------------------------------
 * Bannière cookies Shopify : textes Nook-It (29/09/2026)
 * On ne remplace que les libellés. Les boutons gardent leurs identifiants
 * et leurs actions Shopify (Accepter / Refuser / Préférences).
 * Style : assets/nk-refonte.css (section « Bannière cookies »).
 * ------------------------------------------------------------------------- */
(function () {
  var TITLE = "Avant d'entrer dans l'atelier";
  var BODY = 'Avec nos partenaires (Shopify, Google, Meta), on utilise des cookies pour mesurer la fréquentation du site, adapter nos publicités et retenir vos préférences. Rien ne se déclenche sans votre accord. Tout est détaillé dans la ';
  var BODY_MOBILE = "Avec nos partenaires (Shopify, Google, Meta), on utilise des cookies pour la mesure d'audience, la publicité et vos préférences. Rien sans votre accord. ";

  function dress() {
    var b = document.getElementById('shopify-pc__banner');
    if (!b || b.hasAttribute('data-nk')) return;
    b.setAttribute('data-nk', '');
    var h = b.querySelector('#shopify-pc__banner__body-title');
    if (h) {
      h.textContent = TITLE;
      var k = document.createElement('span');
      k.className = 'nk-pc-kicker';
      k.textContent = 'Cookies';
      h.parentNode.insertBefore(k, h);
    }
    var p = b.querySelector('.shopify-pc__banner__body p');
    var link = b.querySelector('#shopify-pc__banner__body-policy-link');
    if (p && link) {
      var mobile = window.matchMedia('(max-width: 480px)').matches;
      link.textContent = mobile ? 'En savoir plus' : 'politique de confidentialité';
      p.textContent = mobile ? BODY_MOBILE : BODY;
      p.appendChild(link);
      if (!mobile) p.appendChild(document.createTextNode('.'));
    }
    var acc = b.querySelector('#shopify-pc__banner__btn-accept');
    var man = b.querySelector('#shopify-pc__banner__btn-manage-prefs span') || b.querySelector('#shopify-pc__banner__btn-manage-prefs');
    var dec = b.querySelector('#shopify-pc__banner__btn-decline');
    if (acc) acc.textContent = 'Tout accepter';
    if (man) man.textContent = 'Personnaliser';
    if (dec) dec.textContent = 'Continuer sans accepter';
  }

  dress();
  var obs = new MutationObserver(dress);
  obs.observe(document.body, { childList: true });
  setTimeout(function () { obs.disconnect(); }, 20000);
})();
